export enum PageType {
  Category = 'category',
  Partner = 'partner',
  Search = 'search',
  Shop = 'shop',
}

export type FilterNavType = 'sticky filter' | 'collapsed sidebar' | 'fixed sidebar';
